import { render, staticRenderFns } from "./PortalHome.vue?vue&type=template&id=1fce25b0"
import script from "./PortalHome.vue?vue&type=script&lang=js"
export * from "./PortalHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports